export default "__VITE_ASSET__CfdRFWuk__"